var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { DetailViewTypeService } from './detail-view-name-service';
import { ViewType } from '@/domains/base/enums/view-type';
import { LEGACY_VIEW_TYPE_MAP } from '@/domains/detail/dataset/constants';
export const PatentViewTypeService = Symbol('PatentViewTypeService');
let PatentViewTypeServiceImp = class PatentViewTypeServiceImp {
    constructor(_detailViewTypeService) {
        this._detailViewTypeService = _detailViewTypeService;
    }
    getPatentViewPathId() {
        const type = this._detailViewTypeService.getDetailViewType();
        const value = LEGACY_VIEW_TYPE_MAP[type] || LEGACY_VIEW_TYPE_MAP[ViewType.TABLE];
        return value;
    }
};
PatentViewTypeServiceImp = __decorate([
    injectable(),
    __param(0, inject(DetailViewTypeService)),
    __metadata("design:paramtypes", [typeof (_a = typeof DetailViewTypeService !== "undefined" && DetailViewTypeService) === "function" ? _a : Object])
], PatentViewTypeServiceImp);
export { PatentViewTypeServiceImp };
